'use client';

import { FC, useCallback, useMemo } from 'react';
import { ErrorMessage, useField } from 'formik';

import Checkbox, { CheckboxProps } from '@/app/components/Checkbox/Checkbox';

interface FormCheckboxProps extends Omit<CheckboxProps, 'onChange' | 'isChecked' | 'isErrorVisible'> {
  name: string;
  testId?: string;
}

const FormCheckbox: FC<FormCheckboxProps> = (props) => {
  const [field, meta, helpers] = useField(props.name);

  const isErrorVisible = useMemo(() => {
    return !!(meta.error && meta.touched);
  }, [meta.error, meta.touched]);

  const handleChange = useCallback(
    (nextIsChecked: boolean) => {
      helpers.setValue(nextIsChecked);
    },
    [helpers],
  );

  return (
    <Checkbox
      {...props}
      onChange={handleChange}
      isChecked={field.value}
      isErrorVisible={isErrorVisible}
      errorMessage={<ErrorMessage name={props.name} />}
    />
  );
};

export default FormCheckbox;
